import React from 'react';
import { Box, Skeleton } from '@mui/material';

function ConsultorioSkeleton() {
    
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        paddingBottom: '5rem',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'flex-start'
      }}>
      <Box
        sx={{
          display: 'flex',
          width: '920px',
          marginTop: 'calc(3rem + 76px)',
          marginLeft: '4rem',
          height: '100%',
          flexDirection: 'column',
          gap: '2.5rem'
        }}>
        {/* Título */}
        <Box sx={{ display: 'flex', gap: '1rem', alignItems: 'flex-start', flexDirection:'column' }}>
          <Skeleton variant="text" width={250} height={40} animation="wave" />
          <Skeleton variant="text" width={800} height={40} animation="wave" />
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {/* Primer Box */}
          <Skeleton
            animation="wave"
            variant="rectangular"
            width="100%"
            height={200}
            sx={{
              borderRadius: '1rem'
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default ConsultorioSkeleton;
